import { render, staticRenderFns } from "./medlinker.vue?vue&type=template&id=6177d3ea&scoped=true"
import script from "./medlinker.vue?vue&type=script&lang=js"
export * from "./medlinker.vue?vue&type=script&lang=js"
import style0 from "./medlinker.less?vue&type=style&index=0&id=6177d3ea&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177d3ea",
  null
  
)

export default component.exports